import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import BoxSection from '../Layout/BoxSection'
import BoxButton from '../Layout/BoxButton'
import ModalSelectorFromList from '../Shared/ModalSelectorFromList'
import SelectorInput from '../Shared/SelectorInput'

import { showModalSelector, selectFromSelector, downloadFile } from '../../actions/common'
import {
    toggleAllCotizacion,
    updateInputs,
    addProveedorCotizacion,
    removeProveedorCotizacion,
    addCotizacion,
    addGroupOrders,
    removeGroupOrders,
    toggleSelectAllProveedores,
    seleccionarMoneda
} from '../../actions/solicitudbi'

import { isAllowedToViewComponent } from '../../utils/helpers'


class Proveedores extends Component {

    handleOpenSelectorProveedor = (list) => {

        let columns = [
            { id: 1, caption: 'Nit', value: 'identificacion', width: '30%' },
            { id: 2, caption: 'Razon Social', value: 'nombre', width: '70%' }   
        ]
        const payload = {}

        const fn = (a) => {
            payload.path = list
            payload.value = a;
            this.props.selectFromSelector(() => this.props.addProveedorCotizacion(payload));
        }

        this.props.showModalSelector('Listado de proveedores', columns, `/proveedores`, fn)
    }

    getProveedoresUnicos = (bien) => {

        const proveedores = []
        const cotizaciones = bien.get('cotizaciones')

        cotizaciones.valueSeq().forEach(cotizacion => {

            const proveedor_id = cotizacion.get('proveedor_id')
            const index = proveedores.findIndex(proveedor => proveedor.get('id') == proveedor_id)

            if (proveedor_id && index == -1) {

                let proveedor = cotizacion.get('proveedore').set('bien_id', bien.get('id'))

                if (!cotizacion.get('id')) {
                    proveedor = proveedor.set('isNew', true)
                } else {
                    proveedor = proveedor.set('isNew', false)
                }

                proveedores.push(proveedor)

            }
        })

        return proveedores

    }


    handleOpenSelectorMoneda = (moneda) => {
        this.props.seleccionarMoneda(moneda)
    }


	render() {

        const { id, solicitudBI, estado, divisas, moneda } = this.props

        if (!id) return null

        const es_responsable_compras = isAllowedToViewComponent('responsable_compras', solicitudBI)

        const readOnly = ((estado != 2) && (estado != 3) && (estado != 8)) || !es_responsable_compras

        let buttons = [
            <BoxButton key="ba[0][0]" size={14} contrast name="plus-circle" title="Adicionar proveedor" onClick={ () => this.handleOpenSelectorProveedor(`solicitud.bienes`) } disabled={ readOnly }  />,
        ]

		return (
            <div>
                <BoxSection title="Informacion básica para las cotizaciones"> 
                    <div className="row">
                        <div className="col-md-2">
                            <div className="form-group">
                                <label className="control-label">Fecha límite cotizaciones</label>
                                <input type="date" className="form-control input-sm" disabled={estado > 2 && estado < 8}
                                    value={ 
                                        solicitudBI.getIn(['bienes', 0, 'fecha_cotizaciones']) !== '-0001-11-30 00:00:00' ? 
                                            moment(solicitudBI.getIn(['bienes', 0, 'fecha_cotizaciones'])).format('YYYY-MM-DD') : '' 
                                        } 
                                    onChange={ (e) => this.props.updateInputs(`solicitud.bienes.0.fecha_cotizaciones`, e.target.value, solicitudBI.getIn(['bienes',0,'id'])) } 
                                />
                            </div>                        
                        </div>
                        <div className="col-md-10 text-right">
                            <div>
                                <label className="control-label" style={{ marginRight:'10px'}}>Tipo de moneda:</label>
                                <div style ={{alignItems:'flex-end'}} className="btn-group" role="group" aria-label="Basic outlined example">
                                    {
                                        divisas && divisas.map((d,i) => {
                                            return (                                       
                                                <button key={`d[${i}]`} style={{borderRadius: '5px'}} type="button" onClick={ (estado == 1 || estado == 8) ? () => this.handleOpenSelectorMoneda(d.get('CODIGO')) : null } className={ moneda == d.get('CODIGO') ? 'btn btn-primary' : 'btn btn-outline-primary' }>{ d.get('CODIGO') }</button>
                                            );
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </BoxSection>

                <div className="separator"></div>


                <BoxSection title={ `Listado de bienes` } actions={ buttons }>
                    <table className="table table-condensed table-bordered table-striped table-sorted">
                        <thead>
                            <tr>
                                <td width="20px" style={{ textAlign: 'center', verticalAlign: 'middle'}}>
                                    <input 
                                        type="checkbox"                                                    
                                        checked={ solicitudBI.get('bienes').filter(x => x.get('selected')).count() == solicitudBI.get('bienes').count() }
                                        onChange={e => this.props.toggleSelectAllProveedores(e.target.checked)}
                                        disabled = { readOnly }
                                    />                                 
                                </td>
                                <th style={{ width: '15%' }}>Descripción inicial</th>
                                <th style={{ width: '15%' }}>Observación</th>
                                <th style={{ width: '10%' }}>Cantidad</th>
                                <th style={{ width: '10%' }}>Unidad</th>
                                <th style={{ width: '10%', textAlign: 'center' }}>¿Compra directa?</th>
                                <th>Proveedores</th>
                            </tr>
                        </thead>                        
                        <tbody>
                            {
                                solicitudBI.get('bienes').map((x, n) => {

                                    const proveedores = this.getProveedoresUnicos(x)
                                    return(
                                        <tr key={ `tr[24][${n}][${x.get('id')}]` } className={ x.get('selected') ? 'info' : '' }>

                                            <td style={{ textAlign: 'center', verticalAlign: 'middle'}} ><input type="checkbox" style={{ verticalAlign: 'middle' }} checked={ x.get('selected') || false } onChange={ (e) => this.props.updateInputs(`solicitud.bienes.${n}.selected`, e.target.checked) } disabled={readOnly || (x.get('cantidad_solicitada') == 0)} /></td>
                                            <td>{ x.get('descripcion') }</td>

                                            <td>
                                                <input 
                                                    type="text"  
                                                    className="form-control input-sm"                                                  
                                                    disabled={(estado >= 2 && estado < 8) || (x.get('cantidad_solicitada') == 0)} 
                                                    value={ x.get('observaciones') || '' }
                                                    onChange={ (e) => this.props.updateInputs(`solicitud.bienes.${n}.observaciones`, e.target.value) } 
                                                />
                                            </td>

                                            <td style={{ textAlign: 'center'}}>{ x.get('cantidad_solicitada') }</td>

                                            <td style={{ textAlign: 'center'}}>{ x.get('unidad') }</td>

                                            <td style={{ textAlign: 'center', verticalAlign: 'middle'}} >
                                                <input 
                                                    type="checkbox"                                                    
                                                    disabled={readOnly || (x.get('cantidad_solicitada') == 0)} 
                                                    checked={ x.get('compra_directa') }
                                                    onChange={ (e) => this.props.updateInputs(`solicitud.bienes.${n}.compra_directa`, e.target.checked, x.get('id')) } 
                                                />
                                            </td>

                                            <td>
                                            { 
                                                proveedores.map(p => {

                                                    if (p.get('isNew')) {
                                                        return (
                                                            <span 
                                                                key={`p[${x.get('id')}][${p.get('id')}]`} 
                                                                className="label-proveedor-new" 
                                                                title={ p.get('identificacion') } 
                                                                style={{cursor:'pointer'}}
                                                                onClick = {() => this.props.removeProveedorCotizacion(p)}
                                                            >

                                                                    { `x | ${p.get('nombre')}` }

                                                                </span>
                                                        )
                                                    } else {
                                                        return (
                                                            <span key={`p[${x.get('id')}][${p.get('id')}]`} className="label-cenco-dist" title={ p.get('identificacion') }>{ p.get('nombre') }</span>
                                                        )
                                                    }

                                                })
                                            }
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>                    
                    </table>
                </BoxSection>


                <ModalSelectorFromList />
            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        id: state.solicitudBI.get('id'),
        estado: state.solicitudBI.get('estado'),
        solicitudBI: state.solicitudBI.get('solicitud'),
        divisas: state.common.getIn(['parametros', 'DIVISAS']),
        moneda: state.solicitudBI.get('moneda')
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateInputs: (path, value, id) => dispatch(updateInputs(path, value, id)), 
        showModalSelector: (title, fields, url, action, customFilter) => dispatch(showModalSelector(title, fields, url, action, customFilter)),
        toggleAllCotizacion: (path, value) => dispatch(toggleAllCotizacion(path, value)),
        selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),
        addCotizacion: (path, index) => dispatch(addCotizacion(path, index)),
        addProveedorCotizacion: (payload) => dispatch(addProveedorCotizacion(payload)),
        removeProveedorCotizacion: (path) => dispatch(removeProveedorCotizacion(path)),
        addGroupOrders: () => dispatch(addGroupOrders()),
        removeGroupOrders: () => dispatch(removeGroupOrders()),
        downloadFile: (id, filename) => dispatch(downloadFile(id, filename)),
        toggleSelectAllProveedores: (checked) => dispatch(toggleSelectAllProveedores(checked)),
        seleccionarMoneda: (moneda) => dispatch(seleccionarMoneda(moneda)), 
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Proveedores)


// WEBPACK FOOTER //
// ./src/components/SolicitudBI/Proveedores.jsx